export const config = {
  PASSWORD_POLICY_PATTERN:
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])(?!.*?[\s]).{8,20}$/,
  PHONE_NUMBER_PATTERN: /^(\d{3}?)-(\d{3}?)-(\d{4}?)/,
  NAME_PATTERN: /^[0-9a-zA-Z\s]{2,30}$/,
  HISTORY_ON_ONE_PAGE: 10,
  HOMES_TOP: 10000,
  MAX_FLOOR_LENGTH: 49,
  HISTORY_CHECKLISTS: [
    'Activation',
    'Jammed',
    'Locked',
    'Unlocked',
    'Low Battery',
    'Very Low Battery',
    'Too Low to Operate',
    'Out of schedule access attempted',
    'Invalid access limit exceeded',
    'Key Pad / Touch Screen Tamper',
    'Forced Entry',
    'Changed Wi-Fi Credentials',
    'Added BLE Paring',
    'Removed BLE Paring',
    'History Cleared',
    'Forced Entry',
    'Cloud Communication Error',
    'Factory Reset',
    'Network Reset',
  ],
  SOURCES_CHECKLISTS: [
    'Mobile (Wifi, LTE,ETC)',
    'Manual (Turn Piece, Key)',
    'Keypad',
    'Battery Alarm',
    'Unknown Source',
    'BLE',
    'Fingerprint',
    'Alexa',
    'Google Home',
    'Unknown Source',
    'Network',
    'Access Alert',
    'Auto Lock',
    'Tamper Alarm',
    'Device Activation',
    'Device Deactivation',
  ],
  BATTERY: {
    NORMAL: 'Normal Operating State',
    LOW: 'Low Operating State',
    VERY_LOW: 'Very Low Operating State',
    TOO_LOW: 'Too Low to Operate State',
  },
  LANGUAGES: {
    ENGLISH: 'en-us',
    FRENCH: 'fr',
    SPANISH: 'es',
    'en-us': 'English',
    fr: 'French',
    es: 'Spanish',
  },
  PHONEFORMAT: {
    US: { FORMATTEDLENGTH: '14' },
    CA: { FORMATTEDLENGTH: '14' },
    MX: { FORMATTEDLENGTH: '12' },
  },
  MEDIUM_TYPES: {
    PHONE: 'phone',
    EMAIL: 'email',
  },
  CODE_TYPES: {
    DELETE: 'deletion',
    REGISTER: 'registration',
    LOGIN: 'login',
  },
  COOKIE_MAX_AGE: 60 * 60 * 24 * 90,
  UPDATE_STATUS_SECONDS: 6400,

  KEYBOARD_KEY: {
    BACKSPACE: 'Backspace',
  },
  COUNTRIES: {
    US: { COUNTRY_CODE: '+1', COUNTRY_NAME: 'US', FORMATTED_LENGTH: 14 },
  },

  VERSION_INFO: {
    APP_VERSION: '0.1.110.1.10',
    RELEASE_DATE: 'May 6th 2026',
  },
};
